import { Col, Row, Spin } from 'antd';
import download from 'downloadjs';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Apis from '../../../../api';
import useIsTeamMember from '../../../../hooks/useIsTeamMember';
import { HEADERMENU_PATH } from '../../../../routes/RoutesURL';
import { RootState } from '../../../../store/rootReducer';
import HSButton from '../../../common/Button';
import { InvestorStatus } from '../../../login/utils/Status';
import OnboardingCard from '../../onboarding/components/common/Card';
import { DownloadButton } from '../../onboarding/components/nda';

export enum AgreementTypes {
    AIConsent = 'AIConsent',
    SubscriptionAgreement = 'SubscriptionAgreement',
    HIPLAIConsent = 'HIPL AI Consent',
}

const Agreements = () => {
    const navigate = useNavigate();
    const isTeamMember: boolean = useIsTeamMember();

    const [loader, setLoader] = useState<string[]>([]);
    const investor = useSelector((state: RootState) => state.user.investor);

    const investorUUID = investor?.uuid;
    const investorstatus = investor?.status;
    const agreements = investor?.agreements;
    const investorType = investor?.investorType;

    const isHIPLUser = investor?.isHIPL;

    const AIConsent = agreements?.find((a) => a.agreementType === 'AIConsent');
    const aiVenue = AIConsent?.venue;
    const aiStatus = AIConsent?.status;
    const aiAgreementUUID = AIConsent?.uuid;

    const HIPLAIConsent = agreements?.find((a) => a.agreementType === 'HIPL AI Consent');
    const HIPLAiVenue = HIPLAIConsent?.venue;
    const HIPLStatus = HIPLAIConsent?.status;
    const HIPLAgreementUUID = HIPLAIConsent?.uuid;

    const subscriptionAgreement = agreements?.find((a) => a.agreementType === 'SubscriptionAgreement');
    const subVenue = subscriptionAgreement?.venue;
    const subStatus = subscriptionAgreement?.status;
    const subAgreementUUID = subscriptionAgreement?.uuid;

    const downloadFile = (type: string, agreementUUID?: string) => {
        if (investorUUID && agreementUUID) {
            let arr = [...loader];
            const index = arr.indexOf(type);
            if (index === -1) {
                arr.push(type);
            }
            setLoader(arr);
            Apis.downloadFile(investorUUID, agreementUUID)
                .then((res) => {
                    download(new Blob([res.data]), `${type}.pdf`, 'application/pdf');
                })
                .finally(() => {
                    let arr = [...loader];
                    const index = arr.indexOf(type);
                    if (index !== -1) {
                        arr.splice(index, 1);
                    }
                    setLoader(arr);
                });
        }
    };

    return (
        <div className="flex flex-col">
            <p className="page_title_onboarding pt-0 pb-4">Agreements</p>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <NDA />
                </Col>
                <Col xs={24} md={12}>
                    <p className="text-[12px] text-[#747474] WorkSans">AI Consent</p>
                    {AIConsent && (
                        <div className="flex items-center text-[#20222B] text-sm font-bold WorkSans">
                            <div className="flex items-center">
                                Signed <span className="ml-1">{aiVenue}</span>
                                {aiStatus === 'Completed' && loader.indexOf(AgreementTypes.AIConsent) === -1 && (
                                    <DownloadButton
                                        onClick={() => downloadFile(AgreementTypes.AIConsent, aiAgreementUUID)}
                                    />
                                )}
                                {loader.indexOf(AgreementTypes.AIConsent) !== -1 && (
                                    <Spin className="ml-1 h-7 w-8 flex justify-center items-center" />
                                )}
                            </div>
                        </div>
                    )}
                    {!AIConsent && (
                        <div className="py-4">
                            <HSButton
                                title="Complete Agreement"
                                // className="onboarding_btn normal_text"
                                type="primary"
                                onClick={() => !isTeamMember && navigate(HEADERMENU_PATH.signAIConsent)}
                                disabled={
                                    investorstatus?.profile !== InvestorStatus.PendingPostAIAgreements ||
                                    isTeamMember ||
                                    investorstatus?.kyc !== InvestorStatus.KYCApproved ||
                                    investorstatus?.accreditation !== InvestorStatus.AIApproved ||
                                    investorType === 'Institutional'
                                }
                            />
                        </div>
                    )}
                </Col>
                <Col xs={24} md={12}>
                    <p className="text-[12px] text-[#747474] WorkSans">Subscription Agreement</p>
                    {subscriptionAgreement && (
                        <div className="flex items-center text-sm text-[#20222B] font-bold WorkSans">
                            <div className="flex items-center">
                                Signed <span className="ml-1">{subVenue}</span>
                                {subStatus === 'Completed' &&
                                    loader.indexOf(AgreementTypes.SubscriptionAgreement) === -1 && (
                                        <DownloadButton
                                            onClick={() =>
                                                downloadFile(AgreementTypes.SubscriptionAgreement, subAgreementUUID)
                                            }
                                        />
                                    )}
                                {loader.indexOf(AgreementTypes.SubscriptionAgreement) !== -1 && (
                                    <Spin className="ml-1 h-7 w-8 flex justify-center items-center" />
                                )}
                            </div>
                        </div>
                    )}
                    {!subscriptionAgreement && (
                        <div className="py-4">
                            <HSButton
                                title="Complete Agreement"
                                // className="onboarding_btn normal_text"
                                type="primary"
                                onClick={() => navigate(HEADERMENU_PATH.signSubscription)}
                                disabled={
                                    investorstatus?.profile !== InvestorStatus.PendingPostAIAgreements ||
                                    isTeamMember ||
                                    investorstatus?.kyc !== InvestorStatus.KYCApproved ||
                                    investorstatus?.accreditation !== InvestorStatus.AIApproved
                                }
                            />
                        </div>
                    )}
                </Col>
                {isHIPLUser && (
                    <Col xs={24} md={12}>
                        <p className="text-[12px] text-[#747474] WorkSans">HIPL AI Consent</p>
                        {HIPLAIConsent && (
                            <div className="flex items-center text-[#20222B] text-sm font-bold WorkSans">
                                <div className="flex items-center">
                                    Signed <span className="ml-1">{HIPLAiVenue}</span>
                                    {HIPLStatus === 'Completed' &&
                                        loader.indexOf(AgreementTypes.HIPLAIConsent) === -1 && (
                                            <DownloadButton
                                                onClick={() =>
                                                    downloadFile(AgreementTypes.HIPLAIConsent, HIPLAgreementUUID)
                                                }
                                            />
                                        )}
                                    {loader.indexOf(AgreementTypes.HIPLAIConsent) !== -1 && (
                                        <Spin className="ml-1 h-7 w-8 flex justify-center items-center" />
                                    )}
                                </div>
                            </div>
                        )}
                        {!HIPLAIConsent && (
                            <div className="py-4">
                                <HSButton
                                    title="Complete Agreement"
                                    type="primary"
                                    // className="onboarding_btn normal_text"
                                    onClick={() => !isTeamMember && navigate(HEADERMENU_PATH.signHIPLAIConsent)}
                                    disabled={
                                        investorstatus?.profile !== InvestorStatus.PendingPostAIAgreements ||
                                        isTeamMember ||
                                        investorstatus?.kyc !== InvestorStatus.KYCApproved ||
                                        investorstatus?.accreditation !== InvestorStatus.AIApproved
                                    }
                                />
                            </div>
                        )}
                    </Col>
                )}
            </Row>
        </div>
    );
};

const NDA = () => {
    const [loader, setLoader] = useState(false);

    const investorUUID = useSelector((state: RootState) => state.user.investor?.uuid);
    const agreements = useSelector((state: RootState) => state.user.investor?.agreements);
    const NDA = agreements?.find((a) => a.agreementType === 'NDA');
    const ndaVenue = NDA?.venue;
    const ndaStatus = NDA?.status;
    const agreementUUID = NDA?.uuid;

    const downloadFile = (type: string) => {
        if (investorUUID && agreementUUID) {
            setLoader(true);
            Apis.downloadFile(investorUUID, agreementUUID)
                .then((res) => {
                    download(new Blob([res.data]), `${type}.pdf`, 'application/pdf');
                })
                .finally(() => {
                    setLoader(false);
                });
        }
    };
    return (
        <div className="flex flex-col ">
            {/* <p className="page_title_onboarding pt-0 pb-4">Non-Disclosure Agreement</p> */}
            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <p className="text-[12px] text-[#747474] WorkSans">Non-Disclosure Agreement</p>
                    {NDA && (
                        <div className="flex items-center text-[#20222B] WorkSans font-bold text-sm">
                            <div className="flex items-center">
                                {ndaStatus !== 'Skipped' ? `Signed` : 'Skipped'}
                                {ndaStatus !== 'Skipped' && <span>&nbsp;{ndaVenue}</span>}

                                {ndaStatus === 'Completed' && !loader && (
                                    <DownloadButton onClick={() => downloadFile('NDA')} />
                                )}
                                {loader && <Spin className="ml-1 h-7 w-8 flex justify-center items-center" />}
                            </div>
                        </div>
                    )}
                </Col>
            </Row>
        </div>
    );
};

const Wrapper = () => {
    return (
        <div className="pt-4">
            <OnboardingCard>
                <div className="flex-col p-0 md:p-4 flex justify-between w-full">
                    <Agreements />
                </div>
            </OnboardingCard>
        </div>
    );
};

export default Wrapper;
